// removed by extract-text-webpack-plugin
module.exports = {"container":"_1_3jF","slide":"SPxDQ","dots":"ygKd1","dot":"_7sZrH","dot-active":"_1FxKs","navigation":"_22VwR","next":"_3qVTf","previous":"_2PQMq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/PlaceholderCarousel.scss
// module id = ./src/components/Carousel/PlaceholderCarousel.scss
// module chunks = 0 2